window.SnoozebabyCollectionSeo = {
  translations: {
    nl: { expand: 'Lees meer', collapse: 'Lees minder' },
    en: { expand: 'Read more', collapse: 'Read less' },
    fr: { expand: 'Lire la suite', collapse: 'Réduire' },
    de: { expand: 'Mehr lesen', collapse: 'Weniger' },
  },

  truncateSentences(text, maxSentences = 3) {
    const trimmed = text.trim();
    if (!trimmed) return trimmed;

    const DECIMAL_PLACEHOLDER = '\u0000';
    const protectedText = trimmed.replace(/(\d)\.(\d)/g, `$1${DECIMAL_PLACEHOLDER}$2`);

    const parts = protectedText.match(/[^.!?…]+[.!?…]+(?:\s+|$)|[^.!?…]+$/gu);
    if (!parts || parts.length <= maxSentences) return trimmed;

    return parts
      .slice(0, maxSentences)
      .join('')
      .replaceAll(DECIMAL_PLACEHOLDER, '.')
      .trim();
  },

  buildTruncatedIntroHtml(element, maxSentences = 3) {
    const plain = element.textContent.trim();
    const truncated = this.truncateSentences(plain, maxSentences);
    if (!truncated || truncated.length >= plain.length) return null;

    const introRoot = element.cloneNode(true);
    this.trimNodeToLength(introRoot, truncated.length);
    return introRoot.innerHTML;
  },

  trimNodeToLength(root, maxLength) {
    let consumed = 0;
    let done = false;

    const prune = (node) => {
      if (done) {
        node.remove();
        return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        if (consumed + text.length <= maxLength) {
          consumed += text.length;
          return;
        }

        node.textContent = text.slice(0, maxLength - consumed);
        consumed = maxLength;
        done = true;

        let current = node;
        while (current && current !== root) {
          let sibling = current.nextSibling;
          while (sibling) {
            const next = sibling.nextSibling;
            sibling.remove();
            sibling = next;
          }
          current = current.parentNode;
        }
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        Array.from(node.childNodes).forEach((child) => {
          prune(child);
        });
      }
    };

    Array.from(root.childNodes).forEach((child) => {
      prune(child);
    });
  },

  init(contentId, locale) {
    const content = document.getElementById(contentId);
    if (!content) return;

    const plain = content.textContent.trim();
    if (plain.length < 280) return;

    const strings = this.translations[locale] || this.translations.en;
    const fullHtml = content.innerHTML;
    const introHtml = this.buildTruncatedIntroHtml(content, 3);
    if (!introHtml) return;

    content.innerHTML = `<div class="sb-collection-seo__intro">${introHtml}</div><div class="sb-collection-seo__full" hidden>${fullHtml}</div>`;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'readmore-toggle sb-collection-seo__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = strings.expand;
    content.appendChild(toggle);

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const full = content.querySelector('.sb-collection-seo__full');
      const intro = content.querySelector('.sb-collection-seo__intro');
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        full.hidden = true;
        intro.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = strings.expand;
        const header =
          document.querySelector('sticky-header') ||
          document.querySelector('.shopify-section-header-sticky') ||
          document.querySelector('.section-header');
        const offset = (header && header.offsetHeight) || 0;
        const top = content.getBoundingClientRect().top + window.scrollY - offset - 12;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      } else {
        full.hidden = false;
        intro.hidden = true;
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = strings.collapse;
      }
    });
  },
};
